import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import DistributorsRoute from "./distributors/routes";
import Error404 from "../Error404";

const routes = ({ match }) => (
  <Switch>
    <Route exact path={`${match.path}`}>
      <Redirect to={`${match.path}/distributors`} />
    </Route>
    <Route path={`${match.path}/distributors`} component={DistributorsRoute} />
    <Route component={Error404} />
  </Switch>
);

export default routes;
